export default __webpack_public_path__ + "static/media/chatIcon.f28e50f9.svg";